module.exports = global["Tether"] = require("-!/Users/mkramer/Code/masondotnet/node_modules/tether/dist/js/tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
// module id = 79
// module chunks = 0